/**
 * @generated SignedSource<<c95d31ff284aafed377ce61a9e8346f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingWriteAccess = "FULL_WRITE" | "JOIN" | "NONE" | "NON_OWNER_WRITE";
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
export type RestrictionMemberVisibility = "NONE" | "RESTRICTION_ONLY" | "SLOTS_AND_RESTRICTION" | "SLOTS_AND_RESTRICTION_INLINE" | "SLOTS_ONLY";
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
export type useAgendaTeeSheetSlotsChangedSubscription$variables = {
  agendaID: string;
  courseIds?: ReadonlyArray<string> | null | undefined;
  isCustomer: boolean;
  membershipTypeId: string;
  requestConfigs: boolean;
};
export type useAgendaTeeSheetSlotsChangedSubscription$data = {
  readonly agendaSlotsChanged: {
    readonly agenda: {
      readonly blockingRestrictions: {
        readonly edges: ReadonlyArray<{
          readonly liftAt: string | null | undefined;
          readonly node: {
            readonly displayName: string | null | undefined;
            readonly id: string;
            readonly liftBookingRuleWindow?: {
              readonly daysAhead: number;
              readonly time: string;
            } | null | undefined;
            readonly memberMessage?: string | null | undefined;
            readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
            readonly name: string;
            readonly slotCriteria?: {
              readonly allDay: boolean;
              readonly courses: {
                readonly count: number;
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly name: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly endAt: string | null | undefined;
              readonly startAt: string | null | undefined;
            } | null | undefined;
            readonly visibilityColor?: CustomColor | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly configuredRequestRestrictions?: {
        readonly edges: ReadonlyArray<{
          readonly liftAt: string | null | undefined;
          readonly node: {
            readonly displayName: string | null | undefined;
            readonly id: string;
            readonly liftBookingRuleWindow?: {
              readonly daysAhead: number;
              readonly time: string;
            } | null | undefined;
            readonly memberMessage?: string | null | undefined;
            readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
            readonly name: string;
            readonly requestConfig?: {
              readonly id: string;
            } | null | undefined;
            readonly slotCriteria?: {
              readonly allDay: boolean;
              readonly courses: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly endAt: string | null | undefined;
              readonly startAt: string | null | undefined;
            } | null | undefined;
            readonly visibilityColor?: CustomColor | null | undefined;
          } | null | undefined;
          readonly requestCloses: string | null | undefined;
          readonly requestOpens: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly facility: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"getFacilityMemberPermissions_facility">;
      };
      readonly infoRestrictions: {
        readonly edges: ReadonlyArray<{
          readonly liftAt: string | null | undefined;
          readonly node: {
            readonly displayName: string | null | undefined;
            readonly id: string;
            readonly memberMessage?: string | null | undefined;
            readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
            readonly name: string;
            readonly slotCriteria?: {
              readonly allDay: boolean;
              readonly courses: {
                readonly count: number;
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly name: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly endAt: string | null | undefined;
              readonly startAt: string | null | undefined;
            } | null | undefined;
            readonly visibilityColor?: CustomColor | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly requestRestrictions?: {
        readonly edges: ReadonlyArray<{
          readonly liftAt: string | null | undefined;
          readonly node: {
            readonly displayName: string | null | undefined;
            readonly id: string;
            readonly liftBookingRuleWindow?: {
              readonly daysAhead: number;
              readonly time: string;
            } | null | undefined;
            readonly memberMessage?: string | null | undefined;
            readonly name: string;
            readonly slotCriteria?: {
              readonly allDay: boolean;
              readonly courses: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly endAt: string | null | undefined;
              readonly startAt: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly timeSlots: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly availability: SlotAvailability;
            readonly block: {
              readonly id: string;
            } | null | undefined;
            readonly bookings: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly rounds: {
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly __typename: string;
                        readonly player: {
                          readonly __typename: string;
                          readonly firstName: string | null | undefined;
                          readonly id: string;
                          readonly lastName: string | null | undefined;
                        } | null | undefined;
                      } | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                  readonly writeAccess: BookingWriteAccess | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly configuredRequestRestrictions?: {
              readonly edges: ReadonlyArray<{
                readonly liftAt: string | null | undefined;
                readonly node: {
                  readonly displayName: string | null | undefined;
                  readonly id: string;
                  readonly liftBookingRuleWindow?: {
                    readonly daysAhead: number;
                    readonly time: string;
                  } | null | undefined;
                  readonly memberMessage?: string | null | undefined;
                  readonly memberVisibility?: RestrictionMemberVisibility | null | undefined;
                  readonly name: string;
                  readonly requestConfig?: {
                    readonly id: string;
                  } | null | undefined;
                  readonly slotCriteria?: {
                    readonly allDay: boolean;
                    readonly endAt: string | null | undefined;
                    readonly startAt: string | null | undefined;
                  } | null | undefined;
                  readonly visibilityColor?: CustomColor | null | undefined;
                } | null | undefined;
                readonly requestCloses: string | null | undefined;
                readonly requestOpens: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly course: {
              readonly id: string;
              readonly name: string;
            };
            readonly eventSlot: {
              readonly eventSession: {
                readonly id: string;
              };
            } | null | undefined;
            readonly hasHiddenBlockingRestriction: boolean;
            readonly id: string;
            readonly requestRestrictions?: {
              readonly edges: ReadonlyArray<{
                readonly liftAt: string | null | undefined;
                readonly node: {
                  readonly displayName: string | null | undefined;
                  readonly id: string;
                  readonly liftBookingRuleWindow?: {
                    readonly daysAhead: number;
                    readonly time: string;
                  } | null | undefined;
                  readonly memberMessage?: string | null | undefined;
                  readonly name: string;
                  readonly slotCriteria?: {
                    readonly allDay: boolean;
                    readonly endAt: string | null | undefined;
                    readonly startAt: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly time: string;
            readonly waitlistRestrictions: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly " $fragmentSpreads": FragmentRefs<"TimeSlotRow_Timeslot">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    };
  } | null | undefined;
};
export type useAgendaTeeSheetSlotsChangedSubscription = {
  response: useAgendaTeeSheetSlotsChangedSubscription$data;
  variables: useAgendaTeeSheetSlotsChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agendaID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCustomer"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestConfigs"
},
v5 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "agendaIds.0",
        "variableName": "agendaID"
      }
    ],
    "kind": "ListValue",
    "name": "agendaIds"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPrivate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPublic",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicBookingPermissionSet",
  "kind": "LinkedField",
  "name": "publicBookingPermissionSet",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateBookingPermissionSet",
  "kind": "LinkedField",
  "name": "privateBookingPermissionSet",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "bookingType",
  "value": [
    "STANDARD"
  ]
},
v12 = {
  "kind": "Variable",
  "name": "courseIds",
  "variableName": "courseIds"
},
v13 = {
  "kind": "Literal",
  "name": "type",
  "value": [
    "RESTRICTION"
  ]
},
v14 = [
  (v11/*: any*/),
  (v12/*: any*/),
  {
    "kind": "Literal",
    "name": "isBlocking",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "memberVisibility",
    "value": [
      "RESTRICTION_ONLY",
      "SLOTS_AND_RESTRICTION",
      "NONE"
    ]
  },
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberMessage",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityColor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberVisibility",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysAhead",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleWindow",
  "kind": "LinkedField",
  "name": "liftBookingRuleWindow",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allDay",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v28 = [
  (v6/*: any*/),
  (v16/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v28/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  (v12/*: any*/),
  {
    "kind": "Literal",
    "name": "memberVisibility",
    "value": [
      "RESTRICTION_ONLY",
      "SLOTS_AND_RESTRICTION"
    ]
  },
  (v13/*: any*/)
],
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v6/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
],
v33 = [
  (v6/*: any*/)
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseConnection",
  "kind": "LinkedField",
  "name": "courses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v33/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v34/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestOpens",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "RequestConfig",
  "kind": "LinkedField",
  "name": "requestConfig",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": null
},
v39 = [
  (v12/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v40 = {
  "kind": "Variable",
  "name": "membershipTypeId",
  "variableName": "membershipTypeId"
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availability",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeSlotBlock",
  "kind": "LinkedField",
  "name": "block",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Course",
  "kind": "LinkedField",
  "name": "course",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "EventSession",
  "kind": "LinkedField",
  "name": "eventSession",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "writeAccess",
  "storageKey": null
},
v46 = [
  {
    "kind": "Literal",
    "name": "noShowStatus",
    "value": [
      "PRESENT"
    ]
  }
],
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    (v47/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasHiddenBlockingRestriction",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v51 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "WAITLIST"
    ]
  }
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleWindow",
  "kind": "LinkedField",
  "name": "liftBookingRuleWindow",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v53 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v55 = {
  "kind": "Literal",
  "name": "memberVisible",
  "value": true
},
v56 = {
  "kind": "Literal",
  "name": "type",
  "value": "CUSTOMER"
},
v57 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "NINE"
  }
],
v58 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "EIGHTEEN"
  }
],
v59 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      (v47/*: any*/),
      (v6/*: any*/),
      (v16/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      (v54/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": "nineHolePrice",
    "args": (v57/*: any*/),
    "kind": "ScalarField",
    "name": "totalGolfPrice",
    "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
  },
  {
    "alias": "eighteenHolePrice",
    "args": (v58/*: any*/),
    "kind": "ScalarField",
    "name": "totalGolfPrice",
    "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
  }
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "BookingRuleSlotCriteria",
  "kind": "LinkedField",
  "name": "slotCriteria",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v34/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAgendaTeeSheetSlotsChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "AgendaSubscriptionChange",
        "kind": "LinkedField",
        "name": "agendaSlotsChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Agenda",
            "kind": "LinkedField",
            "name": "agenda",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facility",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "getFacilityMemberPermissions_facility",
                    "selections": [
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "blockingRestrictions",
                "args": (v14/*: any*/),
                "concreteType": "AgendaBookingRulesConnection",
                "kind": "LinkedField",
                "name": "bookingRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaBookingRulesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BookingRuleSlotCriteria",
                                "kind": "LinkedField",
                                "name": "slotCriteria",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "BookingRestrictionRule",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "infoRestrictions",
                "args": (v30/*: any*/),
                "concreteType": "AgendaBookingRulesConnection",
                "kind": "LinkedField",
                "name": "bookingRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaBookingRulesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BookingRuleSlotCriteria",
                                "kind": "LinkedField",
                                "name": "slotCriteria",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "BookingRestrictionRule",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "requestConfigs",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "requestRestrictions",
                    "args": (v32/*: any*/),
                    "concreteType": "AgendaBookingRulesConnection",
                    "kind": "LinkedField",
                    "name": "bookingRules",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgendaBookingRulesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  (v23/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "type": "RequestRule",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "bookingRules(type:[\"REQUEST\"])"
                  }
                ]
              },
              {
                "condition": "requestConfigs",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "configuredRequestRestrictions",
                    "args": (v32/*: any*/),
                    "concreteType": "AgendaBookingRulesConnection",
                    "kind": "LinkedField",
                    "name": "requestWindowBookingRules",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgendaBookingRulesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  (v20/*: any*/),
                                  (v19/*: any*/),
                                  (v38/*: any*/),
                                  (v23/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "type": "RequestRule",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                  }
                ]
              },
              {
                "alias": null,
                "args": (v39/*: any*/),
                "concreteType": "TimeSlotConnection",
                "kind": "LinkedField",
                "name": "timeSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              (v40/*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "TimeSlotRow_Timeslot"
                          },
                          (v6/*: any*/),
                          (v22/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSlot",
                            "kind": "LinkedField",
                            "name": "eventSlot",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BookingConnection",
                            "kind": "LinkedField",
                            "name": "bookings",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BookingEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v45/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v46/*: any*/),
                                        "concreteType": "RoundConnection",
                                        "kind": "LinkedField",
                                        "name": "rounds",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RoundEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v47/*: any*/),
                                                  (v48/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "rounds(noShowStatus:[\"PRESENT\"])"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "alias": "requestRestrictions",
                                "args": (v32/*: any*/),
                                "concreteType": "SlotBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "bookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SlotBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              (v23/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "bookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "configuredRequestRestrictions",
                                "args": (v32/*: any*/),
                                "concreteType": "SlotBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "requestWindowBookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SlotBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              (v20/*: any*/),
                                              (v19/*: any*/),
                                              (v38/*: any*/),
                                              (v23/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          {
                            "alias": "waitlistRestrictions",
                            "args": (v51/*: any*/),
                            "concreteType": "SlotBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlotBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v33/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAgendaTeeSheetSlotsChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "AgendaSubscriptionChange",
        "kind": "LinkedField",
        "name": "agendaSlotsChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Agenda",
            "kind": "LinkedField",
            "name": "agenda",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facility",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "blockingRestrictions",
                "args": (v14/*: any*/),
                "concreteType": "AgendaBookingRulesConnection",
                "kind": "LinkedField",
                "name": "bookingRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaBookingRulesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/),
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BookingRuleSlotCriteria",
                                "kind": "LinkedField",
                                "name": "slotCriteria",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v29/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "BookingRestrictionRule",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "infoRestrictions",
                "args": (v30/*: any*/),
                "concreteType": "AgendaBookingRulesConnection",
                "kind": "LinkedField",
                "name": "bookingRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaBookingRulesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v47/*: any*/),
                          (v6/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BookingRuleSlotCriteria",
                                "kind": "LinkedField",
                                "name": "slotCriteria",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v31/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "BookingRestrictionRule",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v39/*: any*/),
                "concreteType": "TimeSlotConnection",
                "kind": "LinkedField",
                "name": "timeSlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dateTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Agenda",
                            "kind": "LinkedField",
                            "name": "agenda",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v41/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "holeOffset",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "groupLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "bookingType",
                                "value": "STANDARD"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "capacity",
                            "storageKey": "capacity(bookingType:\"STANDARD\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "usedCapacity",
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              (v11/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "memberOverride",
                                "value": [
                                  "NONE",
                                  "WARN"
                                ]
                              },
                              {
                                "kind": "Literal",
                                "name": "memberVisibility",
                                "value": "SLOTS_AND_RESTRICTION_INLINE"
                              },
                              (v13/*: any*/)
                            ],
                            "concreteType": "SlotBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlotBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      (v6/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v19/*: any*/)
                                        ],
                                        "type": "BookingRestrictionRule",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "bookingRules(bookingType:[\"STANDARD\"],memberOverride:[\"NONE\",\"WARN\"],memberVisibility:\"SLOTS_AND_RESTRICTION_INLINE\",type:[\"RESTRICTION\"])"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BookingConnection",
                            "kind": "LinkedField",
                            "name": "bookings",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BookingEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "canUpdate",
                                        "storageKey": null
                                      },
                                      (v45/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "ownerClient",
                                        "plural": false,
                                        "selections": [
                                          (v47/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v33/*: any*/),
                                            "type": "Member",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v33/*: any*/),
                                            "type": "Customer",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v33/*: any*/),
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v53/*: any*/),
                                        "type": "StandardBooking",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v53/*: any*/),
                                        "type": "DiningBooking",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v53/*: any*/),
                                        "type": "LessonBooking",
                                        "abstractKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": (v46/*: any*/),
                                        "concreteType": "RoundConnection",
                                        "kind": "LinkedField",
                                        "name": "rounds",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RoundEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v47/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseLayout",
                                                    "kind": "LinkedField",
                                                    "name": "courseLayout",
                                                    "plural": false,
                                                    "selections": [
                                                      (v54/*: any*/),
                                                      (v6/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TransportationType",
                                                    "kind": "LinkedField",
                                                    "name": "transportationType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v54/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "customCode",
                                                        "storageKey": null
                                                      },
                                                      (v16/*: any*/),
                                                      (v6/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v48/*: any*/),
                                                  (v6/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "rounds(noShowStatus:[\"PRESENT\"])"
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSlot",
                            "kind": "LinkedField",
                            "name": "eventSlot",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          {
                            "alias": "waitlistRestrictions",
                            "args": (v51/*: any*/),
                            "concreteType": "SlotBookingRulesConnection",
                            "kind": "LinkedField",
                            "name": "bookingRules",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlotBookingRulesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                          },
                          {
                            "condition": "isCustomer",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 10
                                  },
                                  (v55/*: any*/)
                                ],
                                "concreteType": "CourseLayoutConnection",
                                "kind": "LinkedField",
                                "name": "permittedCourseLayouts",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseLayoutEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseLayout",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v54/*: any*/),
                                          (v16/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "memberVisible",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "enabled",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "default",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "holeCount",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "permittedCourseLayouts(first:10,memberVisible:true)"
                              },
                              {
                                "alias": null,
                                "args": [
                                  (v40/*: any*/),
                                  (v56/*: any*/)
                                ],
                                "concreteType": "SlotRate",
                                "kind": "LinkedField",
                                "name": "playerRateForMembershipType",
                                "plural": false,
                                "selections": (v59/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  (v55/*: any*/)
                                ],
                                "concreteType": "TransportationType",
                                "kind": "LinkedField",
                                "name": "transportationTypes",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": "nineHolePrice",
                                    "args": (v57/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "totalPrice",
                                    "storageKey": "totalPrice(holeCount:\"NINE\")"
                                  },
                                  {
                                    "alias": "eighteenHolePrice",
                                    "args": (v58/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "totalPrice",
                                    "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
                                  }
                                ],
                                "storageKey": "transportationTypes(memberVisible:true)"
                              },
                              {
                                "alias": "rates",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "highestPrecedentOnly",
                                    "value": true
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "nonPlayingHost",
                                    "value": false
                                  },
                                  (v56/*: any*/)
                                ],
                                "concreteType": "SlotRate",
                                "kind": "LinkedField",
                                "name": "playerRates",
                                "plural": true,
                                "selections": (v59/*: any*/),
                                "storageKey": "playerRates(highestPrecedentOnly:true,nonPlayingHost:false,type:\"CUSTOMER\")"
                              }
                            ]
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "alias": "requestRestrictions",
                                "args": (v32/*: any*/),
                                "concreteType": "SlotBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "bookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SlotBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v47/*: any*/),
                                          (v6/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              (v52/*: any*/),
                                              (v60/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "bookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          },
                          {
                            "condition": "requestConfigs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "configuredRequestRestrictions",
                                "args": (v32/*: any*/),
                                "concreteType": "SlotBookingRulesConnection",
                                "kind": "LinkedField",
                                "name": "requestWindowBookingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SlotBookingRulesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v47/*: any*/),
                                          (v6/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              (v20/*: any*/),
                                              (v19/*: any*/),
                                              (v38/*: any*/),
                                              (v52/*: any*/),
                                              (v60/*: any*/)
                                            ],
                                            "type": "RequestRule",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "condition": "requestConfigs",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "requestRestrictions",
                    "args": (v32/*: any*/),
                    "concreteType": "AgendaBookingRulesConnection",
                    "kind": "LinkedField",
                    "name": "bookingRules",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgendaBookingRulesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v47/*: any*/),
                              (v6/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  (v52/*: any*/),
                                  (v61/*: any*/)
                                ],
                                "type": "RequestRule",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "bookingRules(type:[\"REQUEST\"])"
                  }
                ]
              },
              {
                "condition": "requestConfigs",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "configuredRequestRestrictions",
                    "args": (v32/*: any*/),
                    "concreteType": "AgendaBookingRulesConnection",
                    "kind": "LinkedField",
                    "name": "requestWindowBookingRules",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgendaBookingRulesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v47/*: any*/),
                              (v6/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  (v20/*: any*/),
                                  (v19/*: any*/),
                                  (v38/*: any*/),
                                  (v52/*: any*/),
                                  (v61/*: any*/)
                                ],
                                "type": "RequestRule",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "23d7d412d44ff17dc32bacd2f5f02b94",
    "id": null,
    "metadata": {},
    "name": "useAgendaTeeSheetSlotsChangedSubscription",
    "operationKind": "subscription",
    "text": "subscription useAgendaTeeSheetSlotsChangedSubscription(\n  $membershipTypeId: ID!\n  $agendaID: ID!\n  $courseIds: [ID!]\n  $isCustomer: Boolean!\n  $requestConfigs: Boolean!\n) {\n  agendaSlotsChanged(agendaIds: [$agendaID]) {\n    agenda {\n      facility {\n        id\n        ...getFacilityMemberPermissions_facility\n      }\n      blockingRestrictions: bookingRules(type: [RESTRICTION], bookingType: [STANDARD], isBlocking: true, courseIds: $courseIds, memberVisibility: [RESTRICTION_ONLY, SLOTS_AND_RESTRICTION, NONE]) {\n        edges {\n          liftAt\n          node {\n            __typename\n            id\n            name\n            displayName\n            ... on BookingRestrictionRule {\n              memberMessage\n              visibilityColor\n              memberVisibility\n              liftBookingRuleWindow {\n                daysAhead\n                time\n                id\n              }\n              slotCriteria {\n                allDay\n                startAt\n                endAt\n                courses {\n                  count\n                  edges {\n                    node {\n                      id\n                      name\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n      infoRestrictions: bookingRules(type: [RESTRICTION], memberVisibility: [RESTRICTION_ONLY, SLOTS_AND_RESTRICTION], courseIds: $courseIds) {\n        edges {\n          liftAt\n          node {\n            __typename\n            id\n            name\n            displayName\n            ... on BookingRestrictionRule {\n              memberMessage\n              visibilityColor\n              memberVisibility\n              slotCriteria {\n                allDay\n                startAt\n                endAt\n                courses {\n                  count\n                  edges {\n                    node {\n                      name\n                      id\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n      requestRestrictions: bookingRules(type: [REQUEST]) @skip(if: $requestConfigs) {\n        edges {\n          liftAt\n          node {\n            __typename\n            id\n            name\n            displayName\n            ... on RequestRule {\n              memberMessage\n              liftBookingRuleWindow {\n                daysAhead\n                time\n                id\n              }\n              slotCriteria {\n                allDay\n                startAt\n                endAt\n                courses {\n                  edges {\n                    node {\n                      id\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) @include(if: $requestConfigs) {\n        edges {\n          liftAt\n          requestOpens\n          requestCloses\n          node {\n            __typename\n            id\n            name\n            displayName\n            ... on RequestRule {\n              memberMessage\n              memberVisibility\n              visibilityColor\n              requestConfig {\n                id\n              }\n              liftBookingRuleWindow {\n                daysAhead\n                time\n                id\n              }\n              slotCriteria {\n                allDay\n                startAt\n                endAt\n                courses {\n                  edges {\n                    node {\n                      id\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n      timeSlots(first: 1000, courseIds: $courseIds) {\n        edges {\n          node {\n            ...TimeSlotRow_Timeslot_2yMzXk\n            id\n            time\n            availability\n            block {\n              id\n            }\n            course {\n              id\n              name\n            }\n            eventSlot {\n              eventSession {\n                id\n              }\n              id\n            }\n            bookings {\n              edges {\n                node {\n                  __typename\n                  writeAccess\n                  rounds(noShowStatus: [PRESENT]) {\n                    edges {\n                      node {\n                        __typename\n                        player {\n                          id\n                          firstName\n                          lastName\n                          __typename\n                        }\n                        id\n                      }\n                    }\n                  }\n                  id\n                }\n              }\n            }\n            hasHiddenBlockingRestriction\n            requestRestrictions: bookingRules(type: [REQUEST]) @skip(if: $requestConfigs) {\n              edges {\n                liftAt\n                node {\n                  __typename\n                  id\n                  name\n                  displayName\n                  ... on RequestRule {\n                    memberMessage\n                    liftBookingRuleWindow {\n                      daysAhead\n                      time\n                      id\n                    }\n                    slotCriteria {\n                      allDay\n                      startAt\n                      endAt\n                      id\n                    }\n                  }\n                }\n              }\n            }\n            configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) @include(if: $requestConfigs) {\n              edges {\n                liftAt\n                requestOpens\n                requestCloses\n                node {\n                  __typename\n                  id\n                  name\n                  displayName\n                  ... on RequestRule {\n                    memberMessage\n                    memberVisibility\n                    visibilityColor\n                    requestConfig {\n                      id\n                    }\n                    liftBookingRuleWindow {\n                      daysAhead\n                      time\n                      id\n                    }\n                    slotCriteria {\n                      allDay\n                      startAt\n                      endAt\n                      id\n                    }\n                  }\n                }\n              }\n            }\n            waitlistRestrictions: bookingRules(type: [WAITLIST]) {\n              edges {\n                node {\n                  __typename\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment InlineRestrictionsList_timeSlot on TimeSlot {\n  bookingRules(type: [RESTRICTION], bookingType: [STANDARD], memberVisibility: SLOTS_AND_RESTRICTION_INLINE, memberOverride: [NONE, WARN]) {\n    edges {\n      node {\n        __typename\n        id\n        name\n        displayName\n        ... on BookingRestrictionRule {\n          visibilityColor\n        }\n      }\n    }\n  }\n}\n\nfragment PrivateTimeSlotCardWrapper_timeSlot on TimeSlot {\n  ...InlineRestrictionsList_timeSlot\n  id\n  availability\n  bookings {\n    edges {\n      node {\n        __typename\n        canUpdate\n        writeAccess\n        ownerClient {\n          __typename\n          ... on Member {\n            id\n          }\n          ... on Customer {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ... on StandardBooking {\n          status\n        }\n        ... on DiningBooking {\n          status\n        }\n        ... on LessonBooking {\n          status\n        }\n        rounds(noShowStatus: [PRESENT]) {\n          edges {\n            node {\n              __typename\n              courseLayout {\n                code\n                id\n              }\n              transportationType {\n                code\n                customCode\n                name\n                id\n              }\n              player {\n                id\n                firstName\n                lastName\n                __typename\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment PublicTimeSlotCardWrapper_Timeslot_2yMzXk on TimeSlot {\n  ...InlineRestrictionsList_timeSlot\n  permittedCourseLayouts(first: 10, memberVisible: true) {\n    edges {\n      node {\n        id\n        code\n        name\n        memberVisible\n        enabled\n        default\n        holeCount\n      }\n    }\n  }\n  playerRateForMembershipType(membershipTypeId: $membershipTypeId, type: CUSTOMER) {\n    rate {\n      __typename\n      id\n      name\n      type\n      code\n    }\n    nineHolePrice: totalGolfPrice(holeCount: NINE)\n    eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n  }\n  transportationTypes(memberVisible: true) {\n    id\n    nineHolePrice: totalPrice(holeCount: NINE)\n    eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n  }\n  rates: playerRates(highestPrecedentOnly: true, nonPlayingHost: false, type: CUSTOMER) {\n    rate {\n      __typename\n      id\n      name\n      type\n      code\n    }\n    nineHolePrice: totalGolfPrice(holeCount: NINE)\n    eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n  }\n}\n\nfragment TimeSlotRow_Timeslot_2yMzXk on TimeSlot {\n  id\n  time\n  dateTime\n  agenda {\n    date\n    id\n  }\n  availability\n  holeOffset\n  groupLabel\n  capacity(bookingType: STANDARD)\n  usedCapacity\n  block {\n    id\n  }\n  ...PublicTimeSlotCardWrapper_Timeslot_2yMzXk @include(if: $isCustomer)\n  ...PrivateTimeSlotCardWrapper_timeSlot\n  course {\n    id\n    name\n  }\n  bookings {\n    edges {\n      node {\n        __typename\n        id\n        canUpdate\n        writeAccess\n        ownerClient {\n          __typename\n          ... on Member {\n            id\n          }\n          ... on Customer {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ... on StandardBooking {\n          status\n        }\n        ... on DiningBooking {\n          status\n        }\n        ... on LessonBooking {\n          status\n        }\n        rounds(noShowStatus: [PRESENT]) {\n          edges {\n            node {\n              __typename\n              player {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n"
  }
};
})();

(node as any).hash = "50a7227cb0861603fee423ee26305322";

export default node;
